import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import './Modals.css';
import './FootnotesModal.css';

const FootnotesModal = ({ 
  isOpen, 
  onClose, 
  footnotes 
}) => {
  useEffect(() => {
    if (!isOpen) return;
    
    const handleClickOutside = (event) => {
      if (event.target.classList.contains('modal-overlay')) {
        onClose();
      }
    };
    
    const handleEscape = (event) => {
      if (event.key !== 'Escape') return;
      onClose();
      setTimeout(() => document.activeElement?.blur(), 0);
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const hasFootnotes = footnotes && (
    (footnotes.footnote_1 && footnotes.footnote_1.trim()) ||
    (footnotes.footnote_2 && footnotes.footnote_2.trim()) ||
    (footnotes.footnote_3 && footnotes.footnote_3.trim())
  );

  if (!hasFootnotes) return null;

  return createPortal(
    <div className="modal-overlay">
      <div className="footnotes-modal">
        <div className="modal-header">
          <h2>Footnotes</h2>
          <button className="close-button" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="modal-content">
          <div className="footnotes-list">
            {Object.entries(footnotes).map(([key, text]) => {
              const footnoteNumber = key.replace('footnote_', '');
              return (
                <div key={key} className="footnote-item">
                  <span className="footnote-number">{footnoteNumber}</span>
                  <span 
                    className="footnote-text" 
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default FootnotesModal;